import { EMainProductCodeType } from '@aqx-core/common/api/config';
import { ISymbolDetail } from '@aqx-core/common/api/market';

import { numberOrUndefined } from '../number';
import { getDecimalForCompanyIntegration } from './getDecimalFromPrice';
import { kNumberFormatter } from './kNumberFormatter';

export const formatPriceValue = (
  value: number,
  tickRulesGroup: ISymbolDetail['tickRulesGroup'],
  decimal: ISymbolDetail['decimal'],
  overrideCompanyIntegration?: EMainProductCodeType
) => {
  return numberOrUndefined(value) !== undefined
    ? `${kNumberFormatter(value, getDecimalForCompanyIntegration(value, tickRulesGroup, decimal, overrideCompanyIntegration), false)}`
    : '--';
};

export const formatPercentageDiffValue = (percentageDifference: number) => {
  return numberOrUndefined(percentageDifference) !== undefined
    ? `${kNumberFormatter(percentageDifference, 2, false)}%`
    : '0.00%';
};
